import {
  Auth,
  inMemoryPersistence,
  setPersistence,
  signOut,
} from "firebase/auth";

export type AuthBootstrapDependencies = {
  waitUntilReady: () => Promise<void>;
  useMemoryPersistence: () => Promise<void>;
  clearCurrentUser: () => Promise<void>;
};

export const prepareAuthForLaunch = async (
  isKiosk: boolean,
  dependencies: AuthBootstrapDependencies,
) => {
  if (!isKiosk) return;
  await dependencies.waitUntilReady();
  await dependencies.useMemoryPersistence();
  await dependencies.clearCurrentUser();
};

export const createSingleFlightAuthBootstrap = () => {
  let kioskBootstrap: Promise<void> | undefined;

  return (
    isKiosk: boolean,
    dependencies: AuthBootstrapDependencies,
  ): Promise<void> => {
    if (!isKiosk) return Promise.resolve();
    if (kioskBootstrap) return kioskBootstrap;

    const request = prepareAuthForLaunch(true, dependencies);
    kioskBootstrap = request;
    const release = () => {
      if (kioskBootstrap === request) kioskBootstrap = undefined;
    };
    void request.then(release, release);
    return request;
  };
};

export const prepareAuthForAppLaunch = createSingleFlightAuthBootstrap();

export const firebaseAuthBootstrapDependencies = (
  auth: Auth,
): AuthBootstrapDependencies => ({
  waitUntilReady: () => auth.authStateReady(),
  useMemoryPersistence: () => setPersistence(auth, inMemoryPersistence),
  clearCurrentUser: () => signOut(auth),
});
